/**
 * Converts the fontStyle control values to SX style object
 */
// import { IPortal } from '@mcn-platform/models';
// import { applyThemeColor } from '../portal/theme/portalTheme';
const fontStyleToSx = (fontStyle) => ({
    fontSize: `${fontStyle?.fontSize || 14}px`,
    fontWeight: `${fontStyle?.fontWeight || 400}`,
    fontFamily: `${fontStyle?.fontFamily || 'inherit'}`,
    textTransform: fontStyle?.textTransform || 'inherit',
    // color: applyThemeColor(portal, fontStyle?.color) || 'inherit',
    textDecoration: `${(fontStyle?.fontFormat?.includes('underline') && 'underline') || 'inherit'}`,
    fontStyle: `${(fontStyle?.fontFormat?.includes('italic') && 'italic') || 'none'}`,
});
export default fontStyleToSx;
//# sourceMappingURL=fontStyleToSx.js.map